export default __webpack_public_path__ + "static/media/designed-for-everyone.70f5fa4c.jpg";